import React from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import styled from "@emotion/styled";

import { useDispatch, useSelector } from "react-redux";

import { DonationStatus } from "../../../common/enum";

import { setUpdateDonationDetail } from "../slice";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  display: "flex",
  width: "100%",
  padding: "10px",
  position: "relative",
  alignContent: "center",
}));

const AddressCard = ({ item,checked , setChecked }) => {

  const dispatch = useDispatch();
  const {
    auth,
    donationCart: { donationId ,updateDonationDetail},
  } = useSelector((state) => state);

  const { userId } = auth.profile || {};

  const handleClick = () => {
    setChecked(item.addressId);
    const payload = {
      ...updateDonationDetail,
      donationId: donationId,
      status: DonationStatus.new,
      updatedBy: userId,
      addressId: item.addressId,
      isPublish: true,
    };
    dispatch(setUpdateDonationDetail(payload));
  };

  return (
    <>
      <Item
        sx={{
          border: checked === item.addressId ? "2px solid #198754" : "1px solid #dddddd",
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
          mb:1
        }}
        onClick={handleClick}
      >
        {checked === item.addressId ? (
          <img
            src={"/static/selected.png"}
            alt="icon"
            style={{
              width: "40px",
              position: "absolute",
              top: "-2px",
              right: "-2px",
              padding: "0",
            }}
          />
        ) : null}
        <img
          src="/static/dashboard/map.svg"
          alt="map"
          style={{ height: "50px" }}
        />
        <Box marginLeft={"10px"}>
          <Typography fontSize={"subheading"} fontWeight={"bold"}>
            {item.addressTitle}
          </Typography>
          <Typography fontSize={"subheading"}>
            {item.addressLine} {item.locality} {item.subDivision} {item.county}{" "}
            {item.district} {item.postalCode}
          </Typography>
        </Box>
      </Item>
    </>
  );
};

export default AddressCard;
